import Cookies from 'js-cookie'

const TokenKey = 'platformUserToken'
const ExpiresInKey = 'platformExpiresIn'
const UserIdStateKey = 'platformUserId'
const UserPhone = 'platformUserPhone'
const UserName = 'platformUserName'
const ExaminationStateKey = 'examinationState'
const PermissionsKey = "permissions"
const pathId = "pathIdValue"
const roleKey = "platformRole"



export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function getToken() {
    return Cookies.get(TokenKey)
}
export function removeToken() {
    return Cookies.remove(TokenKey)
}

export function setExpiresIn(time) {
    return Cookies.set(ExpiresInKey, time)
}

export function getExpiresIn() {
    return Cookies.get(ExpiresInKey) || -1
}

export function removeExpiresIn() {
    return Cookies.remove(ExpiresInKey)
}

export function setUserId(status) {
    return Cookies.set(UserIdStateKey, status)
}

export function getUserId() {
    return Cookies.get(UserIdStateKey)
}

export function removeUserId() {
    return Cookies.remove(UserIdStateKey)
}

export function setExaminationState(status) {
    return Cookies.set(ExaminationStateKey, status)
}

export function getExaminationState() {
    return Cookies.get(ExaminationStateKey)
}

export function removeExaminationState() {
    return Cookies.remove(ExaminationStateKey)
}

export function setPermissions(permissions) {
    return Cookies.set(PermissionsKey, permissions)
}

export function getPermissions() {
    return Cookies.get(PermissionsKey)
}

export function removePermissions() {
    return Cookies.remove(PermissionsKey)
}

export function setPathId(status) {
    return Cookies.set(pathId, status)
}

export function getPathId() {
    return Cookies.get(pathId)
}

export function removePathId() {
    return Cookies.remove(pathId)
}

export function setUserPhone(status) {
    return Cookies.set(UserPhone, status)
}

export function getUserPhone() {
    return Cookies.get(UserPhone)
}

export function removeUserPhone() {
    return Cookies.remove(UserPhone)
}
export function setUserName(status) {
    return Cookies.set(UserName, status)
}

export function getUserName() {
    return Cookies.get(UserName)
}

export function removeUserName() {
    return Cookies.remove(UserName)
}

export function setPlatformRole(permissions) {
    return Cookies.set(roleKey, permissions)
}

export function getPlatformRole() {
    return Cookies.get(roleKey)
}

export function removePlatformRole() {
    return Cookies.remove(roleKey)
}



